/** One voice for "the system needs something here" — same size, same colour, no fill. */
export default function NeedNote({ children, className = "", testId }) {
  return (
    <p className={`text-xs text-amber-700 ${className}`} data-testid={testId}>
      {children}
    </p>
  );
}
